import { JarvisWebHttpClient } from '@jarvis/web-http';
import { GetTenantRequestDataType } from '../../../clients/stratus/tntCommonResourceRegistry/types';
import { getOneCloudBaseUrl } from '../../../clients/stackUtils';
import { Stack } from '../../../core/types/stratus';
import { GetOnecloudPersonalDomainResponseType, NodeType } from './types';
import { IAuthProviderService } from '../../../services/authProviderService';
import { ShellFlagsInputType } from '../../../infra/startup/types';
import { container } from 'tsyringe';

export default class OnecloudRegistryRelationshipClient {
  private urlPrefix = 'registry-relationship';
  private jarvisWebHttpInstance: JarvisWebHttpClient;
  private apiName = '/ocrel-registry';
  private apiLegacyVersion = '/v2';
  private apiVersion = '/v3';
  private personDomainsEndpoint = '/person/domains';
  private getNodeEndpoint = '/node';
  private _baseUrl: string;
  private _useLegacyOCRelRegistryAPI: boolean;

  constructor({
    stack,
    authProvider
  }: {
    stack: Stack;
    authProvider: IAuthProviderService;
  }) {
    const { enableLegacyOCRelRegistryApi } =
      container.resolve<ShellFlagsInputType>(`ShellFlagsProps`);
    this._useLegacyOCRelRegistryAPI = enableLegacyOCRelRegistryApi ?? false;

    this.jarvisWebHttpInstance = new JarvisWebHttpClient({
      defaultAuthProvider: authProvider
    });

    this._baseUrl = `${getOneCloudBaseUrl(stack, this.urlPrefix)}${
      this.apiName
    }${this.getVersion()}`;
  }

  private getVersion() {
    if (this._useLegacyOCRelRegistryAPI) {
      return this.apiLegacyVersion;
    }
    return this.apiVersion;
  }

  public async getPersonDomains(options?: {
    params?: GetTenantRequestDataType;
  }): Promise<GetOnecloudPersonalDomainResponseType> {
    const { data } = await this.jarvisWebHttpInstance.get({
      url: `${this._baseUrl}${this.personDomainsEndpoint}`,
      params: { ...options?.params }
    });
    return data as GetOnecloudPersonalDomainResponseType;
  }

  public async getNode(options: { nodeId: string }): Promise<NodeType> {
    const { data } = await this.jarvisWebHttpInstance.get({
      url: `${this._baseUrl}${this.getNodeEndpoint}/${options.nodeId}`
    });
    return data as NodeType;
  }
}
